import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { styled } from "@mui/material/styles"

const SpinnerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
}))

const CustomSpinner = () => {
  return (
    <SpinnerContainer>
      <CircularProgress/>
    </SpinnerContainer>
  )
}

export default CustomSpinner
